import { ApplicantType } from '../../../types/identLandingPage';
import { axiosWithToken } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export interface IdentStatusRequest {
  customerRole: ApplicantType;
}

export const checkIdentStatus = async (dataStorageId: string, body: IdentStatusRequest): Promise<any> => {
  const url = `${REACT_APP_API_GATEWAY}/ident/${REACT_APP_BACKEND_BRAND}/${dataStorageId}/status`;

  return axiosWithToken
    .post(url, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
